import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import LocationOnIcon from "@mui/icons-material/LocationOn"; 
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { PolygonData} from "types/models/master/MasterApp";
import { deletePolygon, getPolygon } from "redux/actions";
import { useDispatch } from "react-redux";
import DeleteMessage from "./DeleteMessage";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Tooltip from "@mui/material/Tooltip";


interface OrderActionsProps {
  data: PolygonData;
}

const OrderActions: React.FC<OrderActionsProps> = ({ data }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);

  const handleEdit = () => {
     navigate(`/master/manageViewPolygon/PolygonUpdate/${data.area_id}`);
  };
  const handleDelete = () => {
      setOpenDialog(true);
    };

  
    const handleCloseDialog = () => {
      setOpenDialog(false);
    };
  
    const handleConfirmDelete = () => {
      dispatch(deletePolygon(data) as any) 
        .then(() => {
          dispatch(getPolygon("", 1) as any); 
        })
        .catch((error) => {
          console.error("Error deleting polygon:", error);
        })
        .finally(() => {
          setOpenDialog(false);
        });
    };
 return (
  <Box>
    {isModuleAuthorized("Edit Polygon") ? (
        <IconButton onClick={handleEdit}>
          <img
            src="/assets/images/Location-pin_Comway.svg"
            alt="Location Icon"
            style={{ width: 30, height: 30 }}
          />
        </IconButton>
      ) : (
        <Tooltip title="You don't have permission to edit">
          <span>
            <IconButton disabled>
              <img
                src="/assets/images/Location-pin_Comway.svg"
                alt="Location Icon"
                style={{ width: 30, height: 30, opacity: 0.5 }}
              />
            </IconButton>
          </span>
        </Tooltip>
      )}

    {/* <IconButton onClick={handleDelete}>
      <DeleteIcon style={{ fontSize: 24 }} />
    </IconButton> */}
    <DeleteMessage
      open={openDialog}
      onClose={handleCloseDialog}
      onConfirmDelete={handleConfirmDelete}
    />
  </Box>
);
};

export default OrderActions;
